"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../../utils/scale");
const ItemUser_1 = __importDefault(require("./ItemUser"));
const ItemArticles_1 = __importDefault(require("./ItemArticles"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const ItemLoop = (props) => {
    const { data, displayTweet } = props;
    const subArrayLength = Math.ceil(data?.dataFirebase?.length / 2);
    const ListDataTweetTop = data?.dataFirebase.slice(0, subArrayLength);
    const ListDataTweetBottom = data?.dataFirebase.slice(subArrayLength);
    if (data?.newTweet) {
        [...data.newTweet].reverse().map((item) => {
            ListDataTweetTop.unshift({
                count: 0,
                data: item,
                id: item._id
            });
        });
    }
    return (react_1.default.createElement(react_native_1.View, null,
        ListDataTweetTop && (react_1.default.createElement(react_native_1.FlatList, { data: ListDataTweetTop, showsVerticalScrollIndicator: false, renderItem: (item) => (react_1.default.createElement(ItemUser_1.default, { data: item?.item?.data, idTweet: item?.item?.id, count: item?.item?.count, displayTweet: (data) => displayTweet(data) })), keyExtractor: (item) => item.id })),
        data?.dataNewArticles && data?.dataNewArticles.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { borderBottomWidth: 1, borderColor: '#DDDDDD' } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(18),
                    lineHeight: (0, scale_1.moderateScale)(27),
                    color: '#292A33',
                    marginTop: (0, scale_1.scale)(24),
                    marginLeft: (0, scale_1.scale)(16),
                } }, "\u65B0\u7740\u306E\u8A18\u4E8B"),
            react_1.default.createElement(react_native_1.ScrollView
            // snapToAlignment='center'
            // snapToInterval={width}
            // pagingEnabled
            , { 
                // snapToAlignment='center'
                // snapToInterval={width}
                // pagingEnabled
                contentContainerStyle: { paddingRight: (0, scale_1.scale)(20) }, showsHorizontalScrollIndicator: scale_1.isPC, horizontal: true, style: {
                    flexDirection: 'column',
                    flexWrap: 'wrap',
                    paddingLeft: (0, scale_1.scale)(16),
                } }, data?.dataNewArticles?.map((item, index) => {
                return react_1.default.createElement(ItemArticles_1.default, { data: item, key: index });
            })))),
        ListDataTweetBottom && (react_1.default.createElement(react_native_1.FlatList, { data: ListDataTweetBottom, showsVerticalScrollIndicator: false, renderItem: (item) => (react_1.default.createElement(ItemUser_1.default, { data: item?.item?.data, idTweet: item?.item?.id, count: item?.item?.count, displayTweet: (data) => displayTweet(data) })), keyExtractor: (item) => item.id })),
        data?.dataNewArticlesFollow && data?.dataNewArticlesFollow.length > 0 && (react_1.default.createElement(react_native_1.View, { style: { borderBottomWidth: 1, borderColor: '#DDDDDD' } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(18),
                    lineHeight: (0, scale_1.moderateScale)(27),
                    color: '#292A33',
                    marginTop: (0, scale_1.scale)(24),
                    marginLeft: (0, scale_1.scale)(16),
                } }, "\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3044\u308B\u5148\u8F29\u306E\u8A18\u4E8B"),
            react_1.default.createElement(react_native_1.ScrollView
            // snapToAlignment='center'
            // snapToInterval={width}
            // pagingEnabled
            , { 
                // snapToAlignment='center'
                // snapToInterval={width}
                // pagingEnabled
                contentContainerStyle: {
                    paddingRight: (0, scale_1.scale)(20),
                    borderBottomWidth: 1,
                    borderColor: '#DDDDDD',
                }, showsHorizontalScrollIndicator: scale_1.isPC, horizontal: true, style: {
                    flexDirection: 'column',
                    flexWrap: 'wrap',
                    paddingLeft: (0, scale_1.scale)(16),
                } }, data?.dataNewArticlesFollow?.map((item, index) => {
                return react_1.default.createElement(ItemArticles_1.default, { data: item, key: index });
            }))))));
};
exports.default = ItemLoop;
